var _rect, _rect2, _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 33,
    viewBox: "0 0 25 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.47878,
    y: 25.9225,
    width: 14.0749,
    height: 1.83586,
    rx: 0.91793,
    stroke: "white",
    strokeWidth: 1.83586
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.3146,
    y: 30.2061,
    width: 10.4032,
    height: 1.83586,
    rx: 0.91793,
    stroke: "white",
    strokeWidth: 1.83586
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2102,
    cy: 12.4595,
    r: 10.9331,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6803 25.3105C10.6803 22.8627 10.6803 17.4163 10.6803 15.2133C10.6803 13.6834 9.76241 12.7655 8.5385 12.7655C7.00862 12.7655 6.39667 13.9894 6.39667 14.6013C6.39667 16.1312 7.62057 16.7432 8.5385 16.7432C10.4968 16.7432 11.9042 16.7432 12.5162 16.7432",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3521 25.3105C14.3521 22.8627 14.3521 17.4163 14.3521 15.2133C14.3521 13.6834 15.27 12.7655 16.4939 12.7655C18.0238 12.7655 18.6357 13.9894 18.6357 14.6013C18.6357 16.1312 17.4118 16.7432 16.4939 16.7432C14.5357 16.7432 13.1282 16.7432 12.5162 16.7432",
    stroke: "white",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.8e56d121e4ea334e02282d07bca92d97.svg";
export { ForwardRef as ReactComponent };